import { render, staticRenderFns } from "./addEnclosure.vue?vue&type=template&id=8ac6b432&scoped=true"
import script from "./addEnclosure.vue?vue&type=script&lang=js"
export * from "./addEnclosure.vue?vue&type=script&lang=js"
import style0 from "./addEnclosure.vue?vue&type=style&index=0&id=8ac6b432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac6b432",
  null
  
)

export default component.exports